import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { getInitials } from "helpers/getInitials";
import { getRandomColor } from "helpers/getRandomColor";
import { withVar } from "themes/helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { getAvatarSizing, getLetterSizing } from "./helpers";

export enum TeamAvatarSize {
  ExtraSmall,
  Small,
  Medium,
  Large,
}

interface IStyledAvatarProps {
  color: string;
  width: string;
  height: string;
  lineHeight: string;
}

const StyledAvatar = styled.span<IStyledAvatarProps>`
  position: relative;
  display: inline-block;
  width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.width
  };
  height: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.height
  };
  line-height: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.lineHeight
  };
  border-radius: 2px;
  text-align: center;
  background-color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.color
  };
  vertical-align: middle;

  &.circle {
    border-radius: 50%;
    border: 1px solid ${withVar(DesignToken.ContentInvertPrimary)};
  }

  flex-shrink: 0;
`;

interface IStyledAvatarLetterProps {
  top: string;
  fontSize: string;
}

const StyledAvatarLetter = styled.span<IStyledAvatarLetterProps>`
  position: relative;
  top: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.top
  };
  display: inline-block;
  color: ${withVar(DesignToken.ContentInvertPrimary)};
  font-size: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.fontSize
  };
  text-align: center;
  line-height: 1;
`;

interface IProps {
  id: string;
  name: string;
  className?: string;
  size?: TeamAvatarSize;
  circle?: boolean;
}

export const TeamAvatar: React.FC<IProps> = ({ id, name, size = TeamAvatarSize.Large, className, circle }) => (
  // @ts-expect-error TS(2322)
  <StyledAvatar
    className={[className, circle && "circle"].filter(Boolean).join(" ")}
    color={getRandomColor(id)}
    {...getAvatarSizing(size)}
  >
    <StyledAvatarLetter {...getLetterSizing(size)}>{getInitials(name)}</StyledAvatarLetter>
  </StyledAvatar>
);
